import { useTypedParams } from '@sorare/routing';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';

import { MyCardsRevealableCardsLayout } from '@sorare/gameplay/src/layouts/my-cards/MyCardsRevealableCardsLayout';

import { LayoutParams } from './__generated__/routeParams';

const NBAMyCardsRevealableCardsLayout = () => {
  const { type } = useTypedParams<LayoutParams>();
  return (
    <MyCardsRevealableCardsLayout sport={Sport.NBA} type={type as Rarity} />
  );
};

export default NBAMyCardsRevealableCardsLayout;
